import React from 'react';

function DashboardLayout({ user, onLogout, children }) {
  return (
    <div id="layout-wrapper">
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <span className="logo logo-dark">
                  <span className="logo-sm">
                    <img src="/assets/images/logo-sm.png" alt="Apply Heating" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src="/assets/images/logo-dark.png" alt="Apply Heating" height="17" />
                  </span>
                </span>
                <span className="logo logo-light">
                  <span className="logo-sm">
                    <img src="/assets/images/logo-sm.png" alt="Apply Heating" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src="/assets/images/logo-light.png" alt="Apply Heating" height="17" />
                  </span>
                </span>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div className="dropdown ms-sm-3 header-item topbar-user">
                <button type="button" className="btn">
                  <span className="d-flex align-items-center">
                    <img className="rounded-circle header-profile-user" src="/assets/images/users/avatar-1.jpg" alt="User Avatar" />
                    <span className="text-start ms-xl-2">
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{user?.name || user?.username || 'User'}</span>
                      <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">{user?.level || 'editor'}</span>
                    </span>
                  </span>
                </button>
              </div>
              <form onSubmit={onLogout}>
                <button type="submit" className="btn btn-outline-danger btn-sm ms-2">
                  Logout
                </button>
              </form>
            </div>
          </div>
        </div>
      </header>

      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <span className="logo logo-dark">
            <span className="logo-sm">
              <img src="/assets/images/logo-sm.png" alt="Apply Heating" height="22" />
            </span>
            <span className="logo-lg">
              <img src="/assets/images/logo-dark.png" alt="Apply Heating" height="17" />
            </span>
          </span>
          <span className="logo logo-light">
            <span className="logo-sm">
              <img src="/assets/images/logo-sm.png" alt="Apply Heating" height="22" />
            </span>
            <span className="logo-lg">
              <img src="/assets/images/logo-light.png" alt="Apply Heating" height="17" />
            </span>
          </span>
        </div>

        <div id="scrollbar">
          <div className="container-fluid">
            <ul className="navbar-nav" id="navbar-nav">
              <li className="menu-title">
                <span>Menu</span>
              </li>
              <li className="nav-item">
                <span className="nav-link menu-link">
                  <i className="ri-file-list-3-line" /> <span>Add Checklist</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="sidebar-background" />
      </div>

      <div className="vertical-overlay" />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Checklist Geleverd en Geplaatst</h4>
                </div>
              </div>
            </div>
            {children}
          </div>
        </div>

        <footer className="footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">{new Date().getFullYear()} © Apply Heating.</div>
              <div className="col-sm-6">
                <div className="text-sm-end d-none d-sm-block">Internal Checklist System</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default DashboardLayout;
